/**
 * @voltxampere/ui — 1N4742 12V Zener variant (Sprint 38-3)
 *
 * Reference: Vishay 1N4728-1N4764 series 1N4742 (DO-41 axial Zener).
 *   breakdownVoltage = 12 V           (V_Z @ I_ZT)
 *   breakdownCurrent = 21e-3 A        (I_ZT)
 *
 * Yaygın 12V supply protect / overvoltage clamp.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const zener1n4742 = {
    id: "1n4742",
    nameTr: "1N4742 (Zener 12V, DO41)",
    nameEn: "1N4742 (12V Zener, DO41)",
    shortcut: "Z",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "1N4742 12V",
    schemaType: "zener",
    defaultParams: { breakdownVoltage: 12, breakdownCurrent: 21e-3 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=zener-1n4742.js.map